import { Component } from "@angular/core";

@Component({
  selector: "app-poll",
  standalone: false,
  templateUrl: "./poll.component.html",
  styleUrl: "./poll.component.scss",
})
export class PollComponent {}
